import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import Barcode from 'react-barcode'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const BarcodeComponent = ({value}) => {
    // Prevent hydration mismatch - Barcode renders SVG which may differ between server/client
    const [hasMounted, setHasMounted] = useState(false)
    useEffect(() => {
        setHasMounted(true)
    }, [])

    // Don't render until after hydration to prevent mismatch
    if (!hasMounted) {
        return null
    }

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    overflowX: 'auto',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    '.profile-barcode': {
                        height: 'auto',
                        width: '100%'
                    }
                }}
            >
                <Barcode
                    className="profile-barcode"
                    value={value}
                    width={3}
                    height={40}
                    displayValue={false}
                    background="white"
                    lineColor="black"
                    margin={0}
                    marginTop={10}
                    marginBottom={10}
                />
            </Box>
            <Text variant="barcodeText">
                <FormattedMessage
                    id="barcode.loyalt.id"
                    defaultMessage="Loyalty ID: {loyaltyId}"
                    values={{loyaltyId: value}}
                />
            </Text>
        </>
    )
}

BarcodeComponent.propTypes = {
    value: PropTypes.string.isRequired
}

export default BarcodeComponent
